import CustomBreadcrumbs from './CustomBreadcrumbs';

export default CustomBreadcrumbs;
